import 'dayjs/locale/ja';

import { DatePicker as ANTDPicker, DatePickerProps } from 'antd';
import defaultLocale from 'antd/es/date-picker/locale/ja_JP';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';

type Props = DatePickerProps & {
  disablePast?: boolean;
  disableFuture?: boolean;
};

const DEFAULT_LOCALE: DatePickerProps['locale'] = {
  ...defaultLocale,
  lang: {
    ...defaultLocale.lang,
    shortWeekDays: ['日', '月', '火', '水', '木', '金', '土'],
    shortMonths: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
  },
};

const DatePicker = ({
  locale = DEFAULT_LOCALE,
  disablePast,
  disableFuture,
  disabledDate,
  ...props
}: Props): React.ReactElement => {
  const disabledDateFunc = (current: Dayjs): boolean => {
    if (disablePast && current.isBefore(dayjs().startOf('day'))) {
      return true;
    }
    if (disableFuture && current.isAfter(dayjs().endOf('day'))) {
      return true;
    }

    if (disabledDate) {
      return disabledDate(current);
    }

    return false;
  };

  return (
    <ANTDPicker
      locale={locale}
      disabledDate={disabledDateFunc as any}
      {...props}
    />
  );
};

export default DatePicker;
